// useAuthProtection.js

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAuthProtection = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const isAuthenticated = user !== null;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);
};

export default useAuthProtection;
